// removed by extract-text-webpack-plugin
module.exports = {"cell":"_1zJt30pYH _17qxy1jyE ODSLv4a7K _1IPt6zvnw _1SzzIo45S _2E9qGyV4u _2YXazJPL1 _3v9QXXXDN _3BiTzCAU- Ve18E2zgo OSBVy-e59","content":"_3K5hmGZas _17qxy1jyE _34YKmqAjT _1SzzIo45S _2FytPShLI _1s6tZE1os"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid/grid-header-corner/grid-header-corner.css
 ** module id = 2128
 ** module chunks = 0
 **/